export default __webpack_public_path__ + "static/media/esophagus2.ccb88e1c.jpg";